import { AuthenticationService, TOKEN_KEY } from "./auth.service";

const KEY_ULTIMA = "ultima_atividade";
const KEY_ABA = "aba_aberta";

const TEMPO_LIMITE_INATIVIDADE = 300000; 

const ROTAS_SEM_CONTROLE_ABAS = [
  "/signup/advanced",
  "/signup-candidature",
  "/signup-expired-token",
];

export function iniciarControleAbas() {
  const rotaAtual = globalThis.location.pathname;
  const ehRotaDeCadastro = ROTAS_SEM_CONTROLE_ABAS.some(rota => rotaAtual.includes(rota));

  if (ehRotaDeCadastro) {
    return;
  }

  verificarSessaoAoAbrir();
  iniciarHeartbeat();
  controlarFechamento();
}

function verificarSessaoAoAbrir() {
  const token = localStorage.getItem(TOKEN_KEY);
  const ultima = Number(localStorage.getItem(KEY_ULTIMA) || 0);
  const abaAberta = localStorage.getItem(KEY_ABA);
  const agora = Date.now();
  const diff = agora - ultima;
  
  if (!abaAberta && token && diff > TEMPO_LIMITE_INATIVIDADE) {
    AuthenticationService.logout();
    return;
  }
  localStorage.setItem(KEY_ABA, "true");
}

function iniciarHeartbeat() {
  setInterval(() => {
    if (localStorage.getItem(TOKEN_KEY)) {
      localStorage.setItem(KEY_ULTIMA, Date.now().toString());
    }
  }, 2000);
}

function controlarFechamento() {
  globalThis.addEventListener("pagehide", () => {
    localStorage.setItem(KEY_ULTIMA, Date.now().toString());
    localStorage.removeItem(KEY_ABA);
  });
}